<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block">
		<span class="card-title-label title-label-margin" translate>home.batch-list</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input
				[placeholder]="'search.placeholder' | translate"
				matInput
				type="text"
				spellcheck="false"
				autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<div class="grid-6 copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller" (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<ng-container *ngFor="let batch of scroller.list" >
			<div class="card-portal grid-container grid-column-one-full card-block">
				<div class="card-column">
					<div class="card-container-column space-bottom">
						<span class="card-content-label" translate>batch.reference</span>
						<span>{{ batch.batchReference }}</span>
					</div>	
					<div class="card-container-column">
						<span class="card-content-label" translate>batch.status</span>
						<span class="value-orange">{{ batch.statusDescription }}</span>
					</div>
				</div>
				<div class="card-column">
					<div class="card-container-column space-bottom">
						<span class="card-content-label" translate>order-tracking.steelgrade</span>
						<span>{{ batch.steelgradeDescription ? batch.steelgradeDescription : UNDERSCORE }}</span>
					</div>
					<div class="card-container-column">
						<span class="card-content-label" translate>order.customer.order.number</span>
						<span>{{ batch.customerOrderNumber ? batch.customerOrderNumber + "/" + batch.customerOrderItemNumber : UNDERSCORE }}</span>
					</div>
				</div>
				<div class="card-column">
					<div class="card-container-column space-bottom">
						<span class="card-content-label" translate>order-tracking.dimension</span>
						<span>{{ batch | copoDimension }}</span>
					</div>
					<div class="card-container-row">
						<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
						<span>{{ batch.millDescription }}</span>
					</div>
				</div>
				<div class="card-column">
					<div class="card-container-column space-bottom">
						<span class="card-content-label" translate>order-tracking.customerArticleReference</span>
						<span>{{ batch.customerArticleReference ? batch.customerArticleReference : UNDERSCORE }}</span>
					</div>
					<div class="card-container-column">
						<span class="days-in-stock-value" translate [translateParams]="{ value: batch.daysInStock }">order-tracking.card.callables-batches.days</span>
						<span class="card-content-label" translate>batch.in-stock</span>
					</div>
				</div>
				<div class="card-column card-column-center">
					<div class="card-container-column">
						<span class="tag-tonnage">{{ getBatchQuantity(batch) | copoNumber:'weight':'t' }}</span>
					</div>
					<div class="card-container-row container-view-details">
						<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', batch.id]">
							<span class="view-details-label" translate>delivery-tracking.view-details</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
						</a>
					</div>
				</div>
			</div>
			<div class="card-mobile grid-column-one-full card-block">
				<div class="card-row">
					<div class="card-container-column">
						<span class="card-content-label" translate>batch.reference</span>
						<span class="overflow-wrap">{{ batch.batchReference }}</span>
					</div>
					<span class="tag-tonnage">{{ getBatchQuantity(batch) | copoNumber:'weight':'t' }}</span>
				</div>
				<div class="card-row">
					<div class="card-container-column">
						<span class="card-content-label" translate>order-tracking.steelgrade</span>
						<span class="overflow-wrap">{{ batch.steelgradeDescription ? batch.steelgradeDescription : UNDERSCORE }}</span>
					</div>
					<div class="card-container-column">
						<span class="card-content-label" translate>order-tracking.dimension</span>
						<span class="overflow-wrap">{{ batch | copoDimension }}</span>
					</div>
				</div>
				<div class="card-row">
					<div class="card-container-column">
						<span class="card-content-label" translate>batch.status</span>
						<span class="overflow-wrap value-orange">{{ batch.statusDescription }}</span>
					</div>
					<div class="card-container-row">
						<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
						<span>{{ batch.millDescription }}</span>
					</div>
				</div>
				<div class="card-row">
					<div class="card-column card-column-center">
						<div class="card-container-column card-column-center">
							<span class="days-in-stock-value" translate [translateParams]="{ value: batch.daysInStock }">order-tracking.card.callables-batches.days</span>
							<span class="card-content-label" translate>batch.in-stock</span>
						</div>
					</div>
				</div>
				<div class="card-column card-column-end">
					<div class="container-view-details">
						<a mat-button color="primary" [routerLink]="['/order-tracking/batch/card', batch.id]">
							<span class="view-details-label" translate>delivery-tracking.view-details</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
						</a>
					</div>
				</div>
			</div>
	</ng-container>
		<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text grid-column-one-full" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>